export const colFormRef = 'col-form-subscriber';
